module.exports = __webpack_public_path__ + "static/media/tooltips-marcel.56eae965.png";